import base_config from "./base_config";

const beta_config = {
  ...base_config,
  STAGE: "beta",
  ACCOUNT: "181646698272",
  
  // Authentication Provider Configuration
  // Set to 'AmazonFederate' (default) or 'LASSO' to switch authentication providers
  AUTH_PROVIDER: 'LASSO',  // Using LASSO authentication
  
  // Amplify config for cognito - use getter to ensure runtime evaluation
  get AMPLIFY_CONFIG(): any {
 
    
    // Use the same Client ID for both providers since they share the same Cognito User Pool
    // The Client ID supports both AmazonFederate and LASSO identity providers
    const clientId = "3v6oq88v7lhcv03b2kao7t2bp4";
 
    
    return {
      aws_project_region: base_config.REGION,
      aws_cognito_region: base_config.REGION,
      aws_user_pools_id: "us-west-2_YFbfxWEKk",
      aws_user_pools_web_client_id: "4fjre7i55lopqp3gjb8dsboc80",
      oauth: {
        domain: "msaservice-beta.auth.us-west-2.amazoncognito.com",
        scope: base_config.TOKEN_SCOPES_ARRAY,
        redirectSignIn: base_config.CALL_BACK_URL,
        redirectSignOut: 'https://beta.goh.lab126.amazon.dev/',
        responseType: base_config.OAUTH_RESPONSE_TYPE,
      },
    };
  },

  // API Gateway Base URL
  BASE_URL: "https://api.beta.msa.lab126.amazon.dev",
};

export default beta_config;
